import { typography } from '../global/typography';
import { palette } from '../global/palette';
export const MuiIconButton = {
    MuiIconButton: {
        styleOverrides: {
            root: {
                flex: '0 0 auto',
                fontSize: typography.pxToRem(24),
                padding: 11,
                borderRadius: '50%',
                overflow: 'visible',
                fill: palette.grey[800],
                color: palette.grey[800],
                '&:hover': {
                    backgroundColor: palette.grey[200],
                    '@media (hover: none)': {
                        backgroundColor: 'transparent',
                    },
                },
                '&:active': {
                    backgroundColor: palette.grey[400],
                },
                '&$disabled': {
                    backgroundColor: 'transparent',
                    fill: palette.grey[400],
                    color: palette.grey[400],
                },
            },
            /* Styles applied to the root element if `edge="start"`. */
            edgeStart: {
                marginLeft: -12,
                '$sizeSmall&': {
                    marginLeft: -3,
                },
            },
            /* Styles applied to the root element if `edge="end"`. */
            edgeEnd: {
                marginRight: -12,
                '$sizeSmall&': {
                    marginRight: -3,
                },
            },
            /* Styles applied to the root element if `color="inherit"`. */
            colorInherit: {
                fill: 'inherit',
                color: 'inherit',
            },
            /* Styles applied to the root element if `color="primary"`. */
            colorPrimary: {
                fill: palette.primary.main,
                color: palette.primary.main,
            },
            /* Styles applied to the root element if `color="secondary"`. */
            colorSecondary: {
                fill: palette.secondary.main,
                color: palette.secondary.main,
            },
            /* Styles applied to the root element if `size="small"`. */
            sizeSmall: {
                padding: 8,
                fontSize: typography.pxToRem(16),
            },
        },
        defaultProps: {
            disableTouchRipple: true,
        },
    },
};
